import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { isSupportedRailItem, RailResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { useRailNavigation } from '@/composables/useRailNavigation';
import HorizontalScroller from '@/components/containers/HorizontalScroller.vue';
import GlyphView  from '@/components/glyphs/GlyphView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HorizontalRail',
  props: {
    rail: null,
    railIndex: null,
    railDidNavigateDown: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
  railIndex: number;
  railDidNavigateDown?: (railIndex: number) => void;
};




const { containerId, handleUp, handleDown, handleLeftFallback } =
  useRailNavigation(props);

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const localised = (en: string | null, ga: string | null) => {
  const value = currentLanguage.value === Language.Irish ? ga : en;
  return value ?? en ?? '';
};

const title = computed(() => localised(props.rail.titleEn, props.rail.titleGa));
const subtitle = computed(() => localised(props.rail.subtitleEn, props.rail.subtitleGa));

const railStyle = computed(() => ({
  'background-color': props.rail.backgroundColor ?? undefined,
  color: props.rail.textColor ?? undefined,
}));

const items = computed(() => props.rail.items.filter(isSupportedRailItem));


const showOverlay = computed(() => !props.rail.showItemsAsBoxset && props.rail.overlayTextOnImage);


return { __sfc: true,props, containerId, handleUp, handleDown, handleLeftFallback, useGetter, currentLanguage, localised, title, subtitle, railStyle, items, showOverlay, HorizontalScroller, GlyphView }
}

})